export class LoginService {
    constructor(httpService, authorizationService) {
        this.httpService = httpService;
        this.authorizationService = authorizationService;
    }
    async login(email, password) {
        const response = await this.httpService.post('login', { email, password });
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al efectuar el login.');
        }
        const { accessToken } = await response.json();
        if (!accessToken) {
            throw new Error('Ha ocurrido un error al efectuar el login.');
        }
        this.authorizationService.setToken(accessToken);
    }
}
